var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20333 10.3943C5.0888 10.3938 4.97576 10.3683 4.8721 10.3196C4.76845 10.2709 4.6767 10.2001 4.60326 10.1122L2.42502 7.49596C2.36037 7.41922 2.3119 7.33019 2.28255 7.23423C2.25319 7.13827 2.24355 7.03737 2.2542 6.93759C2.26485 6.83781 2.29558 6.74121 2.34453 6.65361C2.39347 6.56601 2.45964 6.48921 2.53903 6.42785C2.70052 6.30204 2.90445 6.24364 3.10805 6.2649C3.31166 6.28615 3.49913 6.38541 3.63115 6.54186L5.13732 8.34205L9.22377 2.3414C9.3395 2.1727 9.51644 2.05577 9.717 2.01543C9.91756 1.9751 10.1259 2.01454 10.2979 2.12538C10.3856 2.17829 10.4614 2.24873 10.5206 2.33229C10.5798 2.41586 10.6211 2.51074 10.6419 2.611C10.6628 2.71126 10.6627 2.81475 10.6417 2.91498C10.6207 3.01521 10.5792 3.11002 10.5199 3.19349L5.8514 10.0522C5.78435 10.1515 5.69535 10.234 5.59128 10.2933C5.48722 10.3526 5.3709 10.3872 5.25133 10.3943H5.20333Z",
    fill: "#8178EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCheck);
export default __webpack_public_path__ + "static/media/ImgCheck.689100e6a9ecef914debf520303402be.svg";
export { ForwardRef as ReactComponent };